import polyLabel from 'polylabel';

export function getMinMax(points) {
	let minX = points[0].x;
	let maxX = points[0].x;

	let minY = points[0].y;
	let maxY = points[0].y;

	points.forEach((point) => {
		if (point.x < minX) {
			minX = point.x;
		}
		if (point.x > maxX) {
			maxX = point.x;
		}

		if (point.y < minY) {
			minY = point.y;
		}
		if (point.y > maxY) {
			maxY = point.y;
		}
	});

	return {
		minX,
		minY,
		maxX,
		maxY,
	};
}

export function rectToBounds(rect) {
	return [
		{
			x: rect[0].x,
			y: rect[0].y,
		},
		{
			x: rect[0].x + rect[1].x,
			y: rect[0].y + rect[1].y,
		},
	];
}

export function getCenter(points) {
	let sx = 0;
	let sy = 0;

	points.forEach((point) => {
		sx += point.x;
		sy += point.y;
	});

	return [sx / points.length, sy / points.length];
}

export function getVisualCenter(points) {
	return polyLabel([points]);
}

export function boundsToPoints(bounds) {
	return bounds.map((point) => [point.x, point.y]);
}

export function boundsToCoords(bounds) {
	return boundsToPoints(bounds).flat();
}

export function clamp(n, min, max) {
	return Math.max(min, Math.min(n, max));
}

export function clampReverse(n, min, max) {
	return Math.min(min, Math.max(n, max));
}

export function getTouchPosition(touches) {
	let x = 0;
	let y = 0;

	for (let i = 0; i < touches.length; i += 1) {
		const touch = touches[i];
		x += touch.pageX;
		y += touch.pageY;
	}
	return [x / touches.length, y / touches.length];
}

export function getMousePosition(e) {
	return {
		x: e.pageX || e.clientX,
		y: e.pageY || e.clientY,
	};
}

export function getPercentagePosition(ex, ey, wrapperRect, draggableRect) {
	// Get Mouse Position Relative to Wrapper
	const x = ex - wrapperRect.left;
	const y = ey - wrapperRect.top;

	// Get Mouse Position Percentage on the Map
	const xp = (x - (draggableRect.left - wrapperRect.left)) / draggableRect.width;
	const yp = (y - (draggableRect.top - wrapperRect.top)) / draggableRect.height;

	return {
		x: xp,
		y: yp,
	};
}

export function getPositionInViewBox(ex, ey, wrapperRect, draggableRect, viewBox) {
	const { x: xp, y: yp } = getPercentagePosition(ex, ey, wrapperRect, draggableRect);

	// Get Virtual Mouse Position Relative to View Box
	const mapX = viewBox.x + xp * viewBox.width;
	const mapY = viewBox.y + yp * viewBox.height;

	return {
		x: mapX,
		y: mapY,
	};
}

export function mergeBoothLabels(booths) {
	if (booths.length === 1) {
		return `${booths[0].hall.name}/${booths[0].no}`;
	}

	const infos = booths.map((booth) => ({ hall: booth.hall.name, no: booth.no }));
	infos.sort((a, b) => {
		if (a.hall > b.hall) {
			return 1;
		}
		if (a.hall < b.hall) {
			return -1;
		}
		return a.no - b.no;
	});

	const groups = [[infos[0]]];
	let groupIndex = 0;

	for (let i = 1; i < infos.length; i++) {
		const prev = infos[i - 1];
		const current = infos[i];

		if (current.hall !== prev.hall) {
			groups.push([current]);
			groupIndex++;
		} else if (current.no - prev.no > 1) {
			groups.push([current]);
			groupIndex++;
		} else {
			groups[groupIndex][1] = current;
		}
	}

	const finalGroups = [];
	groups.forEach((group) => {
		if (group.length > 1 && group[1].no - group[0].no === 1) {
			finalGroups.push([group[0]], [group[1]]);
		} else {
			finalGroups.push(group);
		}
	});

	return finalGroups.map((group) => group.map((item) => `${item.hall}/${item.no}`).join('-')).join(', ');
}
